export default function (error, enqueueSnackbar) {
    if (error?.data?.errors) {
        Object.values(error.data.errors)?.map((err) => {
            if (Array.isArray(err)) {
                return enqueueSnackbar(err[0], { variant: 'error' });
            }
            return enqueueSnackbar(err, { variant: 'error' });
        });
    }
    if (error?.data?.message) {
        enqueueSnackbar(error?.data?.message, { variant: 'error' });
    }
}
